module.exports = __webpack_public_path__ + "img/powered-by-norven.38a1a59a.svg";